export default __webpack_public_path__ + "static/media/ask.04603f5a.svg";